<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12">
          <h5>Timetables</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable" >
      <div class="col-xl-12">
        <display-timetable :rolesetting="pagepermission"/>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DisplayTimetable from '@/components/timetable/Display/index'

export default {
  components: {
    DisplayTimetable,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('timetable', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  data: function() {
    return {
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
}
</script>
